import React, {useContext} from 'react';
import {SnipcartContext} from 'gatsby-plugin-snipcart-advanced/context';

import styles from './styles.module.css';

const HeaderCart = () => {
  const {state} = useContext(SnipcartContext);
  const {userStatus, cartQuantity} = state;
  return (
    <div className={styles.header__cart}>
      {userStatus === 'SignedOut' ? (
        <button className="snipcart-customer-signin">
          <span>Se connecter</span>
        </button>
      ) : (
        <button className="snipcart-customer-signin">
          <span>Mon compte</span>
        </button>
      )}
      <button className="snipcart-checkout">
        <span>{cartQuantity}</span>
      </button>
    </div>
  );
};

export default HeaderCart;
